var lang = {
    noChoice: "Nepasirinkai atsakymo",
    incorrectAnswer: "Pasirinkai neteisingai. Bandyk dar kartelį",
    correct: "Tęsti",
    incorrect: "Bandyti dar kartą",
    start_test: "Pradėti testą"
}